import { memo, useMemo } from 'react';

import { ResourceOccupation } from '../../../../../../../backend';
import { ganttOneMinuteInMilliSeconds, ganttPxPerMs } from '../../../gantt.constants';
import {
    StyledArrowLeft,
    StyledArrowRight,
    StyledDelayOccupationBox,
    StyledDelayStartBox,
    StyledDeviationBox,
    StyledDeviationZone,
    StyledDottedBox,
} from './DeviationBox.style';

export const DeviationBox = memo(function DeviationBox({
    turnaroundOccupation,
    scheduledTurnaroundOccupation,
    minTimeBetweenUse,
}: {
    turnaroundOccupation: ResourceOccupation;
    scheduledTurnaroundOccupation: ResourceOccupation;
    minTimeBetweenUse: number;
}) {
    const deviations = useMemo(() => {
        let startDeviation = 0;
        if (scheduledTurnaroundOccupation?.occupationStart && turnaroundOccupation?.occupationStart) {
            startDeviation =
                scheduledTurnaroundOccupation.occupationStart.time - turnaroundOccupation.occupationStart.time;
        }
        let endDeviation = 0;
        if (scheduledTurnaroundOccupation?.occupationEnd && turnaroundOccupation?.occupationEnd) {
            endDeviation = turnaroundOccupation.occupationEnd.time - scheduledTurnaroundOccupation.occupationEnd.time;
        }
        return {
            startDeviation,
            endDeviation,
            leftArrow: startDeviation && startDeviation > 0,
            rightArrow: endDeviation && endDeviation > 0,
        };
    }, [
        scheduledTurnaroundOccupation?.occupationEnd,
        scheduledTurnaroundOccupation?.occupationStart,
        turnaroundOccupation?.occupationEnd,
        turnaroundOccupation?.occupationStart,
    ]);

    if (!deviations?.rightArrow && !deviations?.leftArrow) {
        return null;
    }

    return (
        <StyledDeviationZone
            sx={
                deviations?.leftArrow && deviations?.rightArrow
                    ? {
                          justifyContent: 'space-between',
                      }
                    : deviations?.leftArrow
                    ? { justifyContent: 'start' }
                    : { justifyContent: 'end' }
            }
        >
            {deviations?.leftArrow ? (
                deviations.startDeviation <=
                turnaroundOccupation?.occupationEnd.time -
                    turnaroundOccupation?.occupationStart.time +
                    minTimeBetweenUse * ganttOneMinuteInMilliSeconds ? (
                    <StyledDeviationBox width={`${deviations.startDeviation * ganttPxPerMs * 2}px`}>
                        <StyledArrowRight />
                        <StyledDelayOccupationBox />
                        <StyledDelayStartBox />
                    </StyledDeviationBox>
                ) : (
                    <StyledDeviationBox
                        width={`${
                            (turnaroundOccupation?.occupationEnd.time -
                                turnaroundOccupation?.occupationStart.time +
                                minTimeBetweenUse * ganttOneMinuteInMilliSeconds) *
                            ganttPxPerMs *
                            2
                        }px`}
                    >
                        <StyledArrowRight />
                        <StyledDelayOccupationBox />
                        <StyledDottedBox />
                    </StyledDeviationBox>
                )
            ) : null}
            {deviations?.rightArrow ? (
                deviations.endDeviation <=
                turnaroundOccupation?.occupationEnd.time -
                    turnaroundOccupation?.occupationStart.time +
                    minTimeBetweenUse * ganttOneMinuteInMilliSeconds ? (
                    <StyledDeviationBox width={`${deviations.endDeviation * ganttPxPerMs * 2}px`}>
                        <StyledDelayStartBox />
                        <StyledDelayOccupationBox />
                        <StyledArrowLeft />
                    </StyledDeviationBox>
                ) : (
                    <StyledDeviationBox
                        width={`${
                            (turnaroundOccupation?.occupationEnd.time +
                                minTimeBetweenUse * ganttOneMinuteInMilliSeconds -
                                turnaroundOccupation?.occupationStart.time) *
                            ganttPxPerMs *
                            2
                        }px`}
                    >
                        <StyledDottedBox />
                        <StyledDelayOccupationBox />
                        <StyledArrowLeft />
                    </StyledDeviationBox>
                )
            ) : null}
        </StyledDeviationZone>
    );
});
